import { render } from "./WelcomeLayout.vue?vue&type=template&id=317b65a5"
import script from "./WelcomeLayout.vue?vue&type=script&lang=js"
export * from "./WelcomeLayout.vue?vue&type=script&lang=js"

import "./WelcomeLayout.vue?vue&type=style&index=0&id=317b65a5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__